import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, vShow as _vShow, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-selector mb-2" }
const _hoisted_2 = { class: "d-flex justify-content-end gap-1 flex-wrap align-items-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_19 = { key: 5 }
const _hoisted_20 = {
  key: 0,
  class: "my-3"
}
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = {
  key: 0,
  value: "",
  disabled: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "position-relative" }
const _hoisted_26 = {
  key: 1,
  class: "position-absolute top-50 end-0 translate-middle-y me-2"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_29 = { class: "fw-semibold" }
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = {
  key: 0,
  class: "fas fa-check text-primary"
}
const _hoisted_32 = {
  key: 0,
  class: "dropdown-item-text text-muted"
}

import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { useFloating, autoUpdate, offset, flip, shift } from "@floating-ui/vue";
import { useMasterDataHelpers } from "../composables/useMasterDataHelpers";


export default {
  __name: 'FilterSelector',
  props: {
	filterConfigs: {
		type: Array,
		default: () => [],
	},
	availableEquipment: {
		type: Array,
		default: () => [],
	},
	availableRoomTypes: {
		type: Array,
		default: () => [],
	},
	availableUsageTypes: {
		type: Array,
		default: () => [],
	},
	showRoomFilters: {
		type: Boolean,
		default: true,
	},
	showDimOtherBookingsFilter: {
		type: Boolean,
		default: true,
	},
},
  emits: [
	"toggle-bookable-rooms",
	"toggle-dim-other-bookings",
	"update-equipment-selection",
	"update-room-type-selection",
	"update-seat-count",
	"update-usage-type-selection",
	"update-person-selection",
	"remove-filter",
	"reset-all-filters",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Use master data directly
const masterData = useMasterDataHelpers();

// Popover state
const filterPopoverOpen = ref(false);
const addFilterBtn = ref(null);
const filterPopoverEl = ref(null);

// Person search state
const personSearchQuery = ref("");
const personSearchResults = ref([]);
const personSearchLoading = ref(false);
const showPersonDropdown = ref(false);
const selectedPersonId = ref(null);
const selectedPersonName = ref("");
const personSearchRef = ref(null);
const personDropdownEl = ref(null);

// Debounce timer for person search
let personSearchTimeout = null;

// Setup floating UI for popover
const { floatingStyles: filterPopoverStyles } = useFloating(
	addFilterBtn,
	filterPopoverEl,
	{
		middleware: [offset(10), flip(), shift({ padding: 5 })],
		whileElementsMounted: autoUpdate,
	}
);

// Setup floating UI for person search dropdown
const { floatingStyles: personDropdownStyles } = useFloating(
	personSearchRef,
	personDropdownEl,
	{
		middleware: [offset(5), flip(), shift({ padding: 5 })],
		whileElementsMounted: autoUpdate,
		placement: "bottom-start",
	}
);

const activeFilterConfigs = computed(() => {
	return props.filterConfigs.filter((filter) => filter.active);
});

const isBookableRoomsActive = computed(() => {
	const bookableFilter = props.filterConfigs.find(
		(f) => f.id === "bookable-rooms"
	);
	return bookableFilter?.active || false;
});

const isDimOtherBookingsActive = computed(() => {
	const dimFilter = props.filterConfigs.find(
		(f) => f.id === "dim-other-bookings"
	);
	return dimFilter?.active || false;
});

// Get the multi-equipment filter's selected equipment IDs
const getSelectedEquipmentIds = () => {
	const multiEquipmentFilter = props.filterConfigs.find(
		(f) => f.id === "multi-equipment"
	);
	return multiEquipmentFilter?.selectedEquipmentIds || [];
};

// Sorted equipment options alphabetically
const sortedAvailableEquipment = computed(() => {
	return [...props.availableEquipment].sort((a, b) =>
		a.name.localeCompare(b.name, "de-DE", {
			numeric: true,
			sensitivity: "base",
		})
	);
});

// Sorted room type options alphabetically
const sortedAvailableRoomTypes = computed(() => {
	return [...props.availableRoomTypes].sort((a, b) =>
		a.name.localeCompare(b.name, "de-DE", {
			numeric: true,
			sensitivity: "base",
		})
	);
});

// Sorted usage type options alphabetically
const sortedAvailableUsageTypes = computed(() => {
	return [...props.availableUsageTypes].sort((a, b) =>
		a.title.localeCompare(b.title, "de-DE", {
			numeric: true,
			sensitivity: "base",
		})
	);
});

// Get the multi-room-type filter's selected room type IDs
const getSelectedRoomTypeIds = () => {
	const multiRoomTypeFilter = props.filterConfigs.find(
		(f) => f.id === "multi-room-types"
	);
	return multiRoomTypeFilter?.selectedRoomTypeIds || [];
};

// Get the seat count filter's minimum seats
const getSelectedMinSeats = () => {
	const seatCountFilter = props.filterConfigs.find(
		(f) => f.id === "seat-count"
	);
	return seatCountFilter?.minSeats;
};

// Get the usage type filter's selected usage type ID
const getSelectedUsageTypeId = () => {
	const usageTypeFilter = props.filterConfigs.find(
		(f) => f.id === "usage-type"
	);
	return usageTypeFilter?.selectedUsageTypeId || "";
};

// Get the person filter's selected person info
const getSelectedPersonInfo = () => {
	const personFilter = props.filterConfigs.find(
		(f) => f.id === "person-filter"
	);
	return {
		id: personFilter?.selectedPersonId || null,
		name: personFilter?.selectedPersonName || "",
		query: personFilter?.searchQuery || "",
	};
};

// Reactive model for the equipment multi-select
const selectedEquipmentObjects = computed({
	get() {
		const selectedIds = getSelectedEquipmentIds();
		return props.availableEquipment.filter((eq) => selectedIds.includes(eq.id));
	},
	set(_newValue) {
		// This will be handled by the change event
	},
});

// Reactive model for the room type multi-select
const selectedRoomTypeObjects = computed({
	get() {
		const selectedIds = getSelectedRoomTypeIds();
		return props.availableRoomTypes.filter((rt) => selectedIds.includes(rt.id));
	},
	set(_newValue) {
		// This will be handled by the change event
	},
});

// Reactive model for the seat count select
const selectedMinSeats = computed({
	get() {
		const value = getSelectedMinSeats();
		return value !== undefined ? value : "";
	},
	set(_newValue) {
		// This will be handled by the change event
	},
});

// Reactive model for the usage type select
const selectedUsageTypeId = computed({
	get() {
		return getSelectedUsageTypeId();
	},
	set(_newValue) {
		// This will be handled by the change event
	},
});

// Sync person filter state with component state
const syncPersonFilterState = () => {
	const personInfo = getSelectedPersonInfo();

	// Only sync if the state has actually changed to avoid unnecessary updates
	if (
		selectedPersonId.value !== personInfo.id ||
		selectedPersonName.value !== personInfo.name
	) {
		selectedPersonId.value = personInfo.id;
		selectedPersonName.value = personInfo.name;

		// Never put selected person name in search field - it's shown in the filter badge
		// Only clear search field when filter is completely cleared
		if (!personInfo.id) {
			personSearchQuery.value = "";
			personSearchResults.value = [];
			showPersonDropdown.value = false;
		}
	}
};

// Popover functions
const toggleFilterPopover = () => {
	filterPopoverOpen.value = !filterPopoverOpen.value;
};

const closeFilterPopover = () => {
	filterPopoverOpen.value = false;
};

// Close popover when clicking outside
const handleClickOutside = (event) => {
	if (
		filterPopoverOpen.value &&
		filterPopoverEl.value &&
		addFilterBtn.value &&
		!filterPopoverEl.value.contains(event.target) &&
		!addFilterBtn.value.contains(event.target)
	) {
		closeFilterPopover();
	}

	// Close person search dropdown when clicking outside
	if (showPersonDropdown.value) {
		const isClickInsideDropdown =
			personDropdownEl.value && personDropdownEl.value.contains(event.target);
		const isClickInsideInput =
			personSearchRef.value &&
			personSearchRef.value
				.closest(".position-relative")
				.contains(event.target);

		if (!isClickInsideDropdown && !isClickInsideInput) {
			showPersonDropdown.value = false;
		}
	}
};

const toggleBookableRooms = () => {
	emit("toggle-bookable-rooms");
};

const toggleDimOtherBookings = () => {
	emit("toggle-dim-other-bookings");
};

const handleEquipmentSelectionChange = (selectedEquipmentObjects) => {
	const selectedIds = selectedEquipmentObjects.map((eq) => eq.id);
	emit("update-equipment-selection", selectedIds);
};

const clearEquipmentSelection = () => {
	emit("update-equipment-selection", []);
};

const handleRoomTypeSelectionChange = (selectedRoomTypeObjects) => {
	const selectedIds = selectedRoomTypeObjects.map((rt) => rt.id);
	emit("update-room-type-selection", selectedIds);
};

const clearRoomTypeSelection = () => {
	emit("update-room-type-selection", []);
};

const handleSeatCountInput = (event) => {
	const minSeats = parseInt(event.target.value) || undefined;
	if (minSeats && minSeats >= 1) {
		emit("update-seat-count", minSeats);
	} else if (!minSeats) {
		emit("update-seat-count", undefined);
	}
};

const handleSeatCountBlur = (event) => {
	let minSeats = parseInt(event.target.value) || undefined;
	if (minSeats && minSeats < 1) {
		minSeats = 1;
		event.target.value = 1;
	}
	emit("update-seat-count", minSeats);
};

const removeFilter = (filter) => {
	emit("remove-filter", filter);
};

const resetAllFilters = () => {
	emit("reset-all-filters");
};

// Usage type change handler
const handleUsageTypeChange = (event) => {
	const usageTypeId = event.target.value || null;
	emit("update-usage-type-selection", usageTypeId);
};

// Person search handlers
const handlePersonSearchInput = () => {
	// If there was a previous selection and user is typing something different, immediately clear the selection
	if (
		selectedPersonName.value &&
		personSearchQuery.value !== selectedPersonName.value
	) {
		// Clear the selection in the filter immediately
		selectedPersonId.value = null;
		selectedPersonName.value = "";
		emit("update-person-selection", null, null);
	}

	if (personSearchTimeout) {
		clearTimeout(personSearchTimeout);
	}

	personSearchTimeout = setTimeout(() => {
		searchPersons();
	}, 300);
};

const handlePersonSearchFocus = () => {
	showPersonDropdown.value = true;
	// If we have results for the current query, show them
	if (personSearchQuery.value && personSearchResults.value.length > 0) {
		return;
	}
	// Otherwise start a search if there's a query
	if (personSearchQuery.value.trim()) {
		searchPersons();
	}
};

const searchPersons = async () => {
	if (!personSearchQuery.value.trim()) {
		personSearchResults.value = [];
		return;
	}

	personSearchLoading.value = true;

	try {
		// Get API URLs from DOM (similar to BookingForOthers.vue)
		const studentSearchUrl =
			document.getElementById("vue-container")?.dataset.studentSearchApiUrl;
		const employeeSearchUrl =
			document.getElementById("vue-container")?.dataset.employeeSearchApiUrl;

		const searchPromises = [];

		// Search students
		if (studentSearchUrl) {
			const studentUrl = `${studentSearchUrl}?q=${encodeURIComponent(
				personSearchQuery.value
			)}`;
			searchPromises.push(
				fetch(studentUrl, {
					method: "GET",
					headers: { Accept: "application/json" },
					credentials: "same-origin",
				})
					.then((response) => (response.ok ? response.json() : { items: [] }))
					.then((data) => ({
						type: "student",
						items: data.items || [],
					}))
			);
		}

		// Search employees
		if (employeeSearchUrl) {
			const employeeUrl = `${employeeSearchUrl}?q=${encodeURIComponent(
				personSearchQuery.value
			)}`;
			searchPromises.push(
				fetch(employeeUrl, {
					method: "GET",
					headers: { Accept: "application/json" },
					credentials: "same-origin",
				})
					.then((response) => (response.ok ? response.json() : { items: [] }))
					.then((data) => ({
						type: "employee",
						items: data.items || [],
					}))
			);
		}

		const results = await Promise.all(searchPromises);
		const allPersons = [];

		results.forEach((result) => {
			result.items.forEach((item) => {
				allPersons.push({
					id: item.id,
					name: item.name,
					email: result.type === "student" ? item.studentId : item.email,
					type: result.type,
				});
			});
		});

		personSearchResults.value = allPersons;
	} catch (error) {
		console.error("Person search error:", error);
		personSearchResults.value = [];
	} finally {
		personSearchLoading.value = false;
	}
};

const selectPerson = (person) => {
	selectedPersonId.value = person.id;
	selectedPersonName.value = person.name;
	personSearchQuery.value = ""; // Clear search field after selection
	showPersonDropdown.value = false;
	personSearchResults.value = [];

	emit("update-person-selection", person.id, person.name);
};

const clearPersonSearch = () => {
	personSearchQuery.value = "";
	personSearchResults.value = [];
	showPersonDropdown.value = false;
};

const getFilterIcon = (filter) => {
	if (filter.id === "bookable-rooms") return "fas fa-calendar-plus";
	if (filter.id === "dim-other-bookings") return "fas fa-eye-slash";
	if (filter.id.startsWith("equipment-") || filter.id === "multi-equipment")
		return "fas fa-tools";
	if (filter.id === "multi-room-types") return "fas fa-tag";
	if (filter.id === "seat-count") return "fas fa-chair";
	if (filter.id === "usage-type") return "fas fa-clipboard-list";
	if (filter.id === "person-filter") return "fas fa-user-search";
	return null;
};

// Lifecycle hooks
onMounted(() => {
	document.addEventListener("click", handleClickOutside);
	// Sync person filter state on mount
	syncPersonFilterState();
});

onUnmounted(() => {
	document.removeEventListener("click", handleClickOutside);
	if (personSearchTimeout) {
		clearTimeout(personSearchTimeout);
	}
});

// Watch for filter config changes to sync person state
watch(
	() => props.filterConfigs,
	() => {
		syncPersonFilterState();
	},
	{ deep: true }
);

return (_ctx, _cache) => {
  const _component_VMultiselect = _resolveComponent("VMultiselect")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" All Filter Elements in One Row "),
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" Active Filter Badges "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFilterConfigs.value, (filter) => {
          return (_openBlock(), _createElementBlock("button", {
            key: filter.id,
            type: "button",
            class: "btn btn-xs filter-badge active",
            onClick: $event => (removeFilter(filter))
          }, [
            (getFilterIcon(filter))
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass([getFilterIcon(filter), "me-1"])
                }, null, 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(filter.displayLabel || filter.label) + " ", 1 /* TEXT */),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "filter-close-icon ms-1" }, [
              _createElementVNode("i", { class: "fas fa-times" })
            ], -1 /* CACHED */))
          ], 8 /* PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" Reset All Filters Button "),
        (activeFilterConfigs.value.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-xs btn-outline-danger",
              title: "Alle Filter zurücksetzen",
              onClick: resetAllFilters
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1 /* CACHED */),
              _createTextVNode(" Zurücksetzen ", -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Add Filter Button "),
        _createElementVNode("button", {
          ref_key: "addFilterBtn",
          ref: addFilterBtn,
          type: "button",
          class: "btn btn-xs btn-outline-secondary",
          onClick: toggleFilterPopover
        }, " Anzeigeoptionen ändern ", 512 /* NEED_PATCH */)
      ])
    ]),
    _createCommentVNode(" Filter Popover "),
    (filterPopoverOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "filterPopoverEl",
          ref: filterPopoverEl,
          style: _normalizeStyle([_unref(filterPopoverStyles), {"z-index":"1050","min-width":"280px","overflow":"visible"}]),
          class: "popover-content bg-white border shadow-sm rounded p-3"
        }, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
            _createElementVNode("h6", { class: "mb-0 fw-bold" }, " Anzeigeoptionen ändern ")
          ], -1 /* CACHED */)),
          _createCommentVNode(" Bookable Rooms Toggle "),
          (__props.showRoomFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("input", {
                    id: "bookable-rooms-toggle",
                    type: "checkbox",
                    class: "form-check-input",
                    checked: isBookableRoomsActive.value,
                    onChange: toggleBookableRooms
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    for: "bookable-rooms-toggle",
                    class: "form-check-label"
                  }, [
                    _createElementVNode("i", { class: "fas fa-calendar-plus me-1" }),
                    _createTextVNode(" Nur buchbare Räume anzeigen ")
                  ], -1 /* CACHED */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Dim Other Bookings Toggle (only for students/employees) "),
          (
        __props.showDimOtherBookingsFilter &&
          (_unref(masterData).userRole?.value === 'student' ||
            _unref(masterData).userRole?.value === 'employee'
          )
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    id: "dim-other-bookings-toggle",
                    type: "checkbox",
                    class: "form-check-input",
                    checked: isDimOtherBookingsActive.value,
                    onChange: toggleDimOtherBookings
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9),
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "dim-other-bookings-toggle",
                    class: "form-check-label"
                  }, [
                    _createElementVNode("i", { class: "fas fa-eye-slash me-1" }),
                    _createTextVNode(" Fremde Buchungen abdunkeln ")
                  ], -1 /* CACHED */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Equipment Multi-Selector "),
          (__props.showRoomFilters && __props.availableEquipment.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label fw-bold" }, "Ausstattung", -1 /* CACHED */)),
                _createVNode(_component_VMultiselect, {
                  modelValue: selectedEquipmentObjects.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = $event => ((selectedEquipmentObjects).value = $event)),
                    handleEquipmentSelectionChange
                  ],
                  options: sortedAvailableEquipment.value,
                  "track-by": "id",
                  label: "name",
                  multiple: true,
                  "close-on-select": false,
                  searchable: true,
                  placeholder: "Ausstattung wählen...",
                  "select-label": "Eintrag auswählen",
                  "selected-label": "✓",
                  "deselect-label": "Auswahl aufheben"
                }, {
                  selection: _withCtx(({ values, isOpen }) => [
                    (values.length === 1 && !isOpen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(values[0].name), 1 /* TEXT */))
                      : (values.length > 1 && !isOpen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(values.length) + " Ausstattungen", 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13))
                  ]),
                  beforeList: _withCtx(() => [
                    _createElementVNode("li", {
                      class: "multiselect__option",
                      onClick: clearEquipmentSelection
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                      _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                    ]))])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Room Types Multi-Selector "),
          (__props.showRoomFilters && __props.availableRoomTypes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label fw-bold" }, "Raumtyp", -1 /* CACHED */)),
                _createVNode(_component_VMultiselect, {
                  modelValue: selectedRoomTypeObjects.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = $event => ((selectedRoomTypeObjects).value = $event)),
                    handleRoomTypeSelectionChange
                  ],
                  options: sortedAvailableRoomTypes.value,
                  "track-by": "id",
                  label: "name",
                  multiple: true,
                  "close-on-select": false,
                  searchable: false,
                  placeholder: "Raumtypen wählen...",
                  "select-label": "Eintrag auswählen",
                  "selected-label": "✓",
                  "deselect-label": "Auswahl aufheben"
                }, {
                  selection: _withCtx(({ values, isOpen }) => [
                    (values.length === 1 && !isOpen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(values[0].name), 1 /* TEXT */))
                      : (values.length > 1 && !isOpen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(values.length) + " Raumtypen", 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17))
                  ]),
                  beforeList: _withCtx(() => [
                    _createElementVNode("li", {
                      class: "multiselect__option",
                      onClick: clearRoomTypeSelection
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                      _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                    ]))])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Seat Count Input "),
          (__props.showRoomFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "seatCountInput",
                  class: "form-label fw-bold"
                }, "Mindest-Sitzplätze", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  id: "seatCountInput",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((selectedMinSeats).value = $event)),
                  type: "number",
                  class: "form-control form-control-sm",
                  min: "0",
                  step: "1",
                  placeholder: "z.B. 20",
                  onInput: handleSeatCountInput,
                  onBlur: handleSeatCountBlur
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [
                    _vModelText,
                    selectedMinSeats.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Booking Filters (only for employees) "),
          (_unref(masterData).canViewOtherBookings?.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (__props.showRoomFilters)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_20))
                  : _createCommentVNode("v-if", true),
                _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "mb-3 fw-bold text-muted" }, [
                  _createElementVNode("i", { class: "fas fa-calendar-check me-1" }),
                  _createTextVNode(" Buchungsfilter ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" Usage Type Selector "),
                _createElementVNode("div", _hoisted_21, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-bold" }, "Nutzungsart", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((selectedUsageTypeId).value = $event)),
                    class: "form-select form-select-sm",
                    onChange: handleUsageTypeChange
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, " Alle Nutzungsarten ", -1 /* CACHED */)),
                    (sortedAvailableUsageTypes.value.length === 0)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_22, " Laden... "))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedAvailableUsageTypes.value, (usageType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: usageType.id,
                        value: usageType.id
                      }, _toDisplayString(usageType.title), 9 /* TEXT, PROPS */, _hoisted_23))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, selectedUsageTypeId.value]
                  ])
                ]),
                _createCommentVNode(" Person Search "),
                _createElementVNode("div", _hoisted_24, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-bold" }, "Person suchen", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((personSearchQuery).value = $event)),
                      type: "text",
                      class: "form-control form-control-sm",
                      placeholder: "Name oder E-Mail eingeben...",
                      onInput: handlePersonSearchInput,
                      onFocus: handlePersonSearchFocus,
                      onClick: handlePersonSearchFocus
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, personSearchQuery.value]
                    ]),
                    _createCommentVNode(" Clear button for search input "),
                    (personSearchQuery.value && !selectedPersonName.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "position-absolute top-50 end-0 translate-middle-y me-2 btn btn-sm",
                          style: {"border":"none","background":"none","padding":"0.25rem"},
                          onClick: clearPersonSearch
                        }, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "fas fa-times text-muted" }, null, -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Loading indicator "),
                    (personSearchLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("div", {
                            class: "spinner-border spinner-border-sm",
                            role: "status"
                          }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Wird geladen...")
                          ], -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Dropdown positioning reference (invisible) "),
                    _createElementVNode("div", {
                      ref_key: "personSearchRef",
                      ref: personSearchRef,
                      class: "dropdown-reference"
                    }, null, 512 /* NEED_PATCH */)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Person Search Dropdown (teleported to body to avoid popover clipping) "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", {
        ref_key: "personDropdownEl",
        ref: personDropdownEl,
        style: _normalizeStyle([_unref(personDropdownStyles), {"max-height":"200px","overflow-y":"auto","z-index":"2000","position":"fixed","min-width":"200px"}]),
        class: "dropdown-menu show person-search-dropdown-teleported"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personSearchResults.value, (person) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `${person.type}-${person.id}`,
            type: "button",
            class: _normalizeClass(["dropdown-item", { active: person.id === selectedPersonId.value }]),
            onClick: $event => (selectPerson(person))
          }, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(person.name), 1 /* TEXT */),
                _createElementVNode("small", _hoisted_30, _toDisplayString(person.email), 1 /* TEXT */)
              ]),
              (person.id === selectedPersonId.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                : _createCommentVNode("v-if", true)
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_27))
        }), 128 /* KEYED_FRAGMENT */)),
        (
          personSearchQuery.value &&
            personSearchResults.value.length === 0 &&
            !personSearchLoading.value
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Keine Ergebnisse gefunden "))
          : _createCommentVNode("v-if", true)
      ], 4 /* STYLE */), [
        [_vShow, 
        showPersonDropdown.value &&
          (personSearchResults.value.length > 0 ||
            (personSearchQuery.value && personSearchQuery.value.length > 0))
      ]
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

}